"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _react = _interopRequireDefault(require("react"));

var _reactHookForm = require("react-hook-form");

var _reactRedux = require("react-redux");

var _gifting = require("../../gifting.types");

var _GiftActionsField = _interopRequireDefault(require("../../GiftActionsField/GiftActionsField"));

var _RecipientActionsTextfield = require("../../RecipientActions/RecipientActionsTextfield");

var _RecipientActionsSelector = require("../../RecipientActions/RecipientActionsSelector");

var _gift = require("../../../../CreateGift/store/gift/gift.selector");

var GiftActionsContainer = function GiftActionsContainer(_ref) {
  var control = _ref.control;
  var originalGift = (0, _reactRedux.useSelector)(_gift.getOriginalGift);
  var isRequiredActionsLocked = originalGift.required_actions.locked;
  var watchedActions = (0, _reactHookForm.useWatch)({
    control,
    name: _gifting.GiftActionsFields.RecipientActions
  });

  var hasRecipientAction = function hasRecipientAction(action) {
    return watchedActions.includes(action);
  };

  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_RecipientActionsSelector.RecipientActionsSelector, {
    name: _gifting.GiftActionsFields.RecipientActions,
    control: control,
    disabled: isRequiredActionsLocked
  }), hasRecipientAction('capture_affidavit') && /*#__PURE__*/_react.default.createElement(_RecipientActionsTextfield.RecipientActionsTextField, {
    name: _gifting.GiftActionsFields.GifterAffidavit,
    control: control,
    label: "Terms to agree to",
    placeholder: "Enter terms to agree to",
    disabled: isRequiredActionsLocked
  }), hasRecipientAction('capture_question') && /*#__PURE__*/_react.default.createElement(_RecipientActionsTextfield.RecipientActionsTextField, {
    name: _gifting.GiftActionsFields.GifterQuestion,
    control: control,
    label: "Questions to ask",
    placeholder: "Your questions",
    disabled: isRequiredActionsLocked
  }), /*#__PURE__*/_react.default.createElement(_GiftActionsField.default, {
    control: control
  }));
};

var _default = GiftActionsContainer;
exports.default = _default;